import Hero from "../../designSystem/Hero";
import PrimaryButtonSmall from "../../designSystem/buttons/PrimaryButtonSmall";
import MortgageRepaymentCalculator from "../../calculators/MortgageRepaymentCalculator";
import SEO from "../../designSystem/SEO";
import CalculatorImage from "../../../assets/images/homepage_01.png";

const MortgageRepaymentCalculatorsPage = () => {
  return (
    <div>
      <SEO
        title="Mortgage Repayment Calculator"
        description="Estimate monthly mortgage repayments by entering your loan amount, mortgage term and interest rate with CAPC Mortgages."
        path="/calculators/mortgage-repayment"
      />
      <Hero
        title=""
        subtitle=""
        backgroundImage={CalculatorImage}
        titleAlign="left"
        subtitleAlign="left"
        wantOverlay={false}
      >
        <div className="content-container">
          <div className="column gap-m align-center">
            <div className="nav-text text-secondary-1 uppercase">
              Mortgage Calculators
            </div>
            <h1 className="text-primary-1 text-center">
              What will my monthly repayments be?
            </h1>
            <div className="content text-primary-2 text-center">
              Use our repayment calculator to assess your monthly repayments.
            </div>
            <PrimaryButtonSmall text="contact us" />
          </div>
        </div>
      </Hero>

      <MortgageRepaymentCalculator />

    </div>
  );
};

export default MortgageRepaymentCalculatorsPage;
